import React, { useEffect, useRef } from "react";
import { Form, FormInstance, Input, Modal, Radio } from "antd";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "../styled/form.styled";

export interface IVehicleActionProps {
  activeTab: string;
  formVehicleAction: FormInstance;
  vehicleActionSelected: number;
  allowRequestDockEntryAction: boolean;
  disabledButtonSaveVehicle: boolean;
  allowRequestVehicleInboundAction: boolean;
  visibleModalVehicleAction: boolean;
  setVehicleActionSelected: (...args) => void;
  onChangeRadioVehicleAction: (...args) => void;
  handleClickConfirmVehicleAction: (...args) => void;
  lobbyHideModalVehicleAction: (...args) => void;
}

const VehicleAction = ({
  activeTab,
  formVehicleAction,
  vehicleActionSelected,
  allowRequestDockEntryAction,
  allowRequestVehicleInboundAction,
  visibleModalVehicleAction,
  disabledButtonSaveVehicle,
  setVehicleActionSelected,
  onChangeRadioVehicleAction,
  handleClickConfirmVehicleAction,
  lobbyHideModalVehicleAction,
}: IVehicleActionProps): JSX.Element => {
  const inputDock = useRef(null);
  const LOBBY = useTranslation({ id: "lobby" });
  const DOCK = useTranslation({ id: "dock" });
  const CALL_VEHICLE_TO_LOBBY_DESCRIPTION = useTranslation({ id: "call_vehicle_to_lobby_description" });
  const DRIVER_WARNING_DESCRIPTION = useTranslation({ id: "driver_warning_description" });
  const INFORM_DOCK_ADDRESS = useTranslation({ id: "inform_dock_address" });
  const REQUIRED_FIELD = useTranslation({ id: "required_field" });
  const ADDRESS = useTranslation({ id: "address" });
  const featuredVehiclesActiveTab = "1";
  const vehiclesInLocationActiveTab = "2";
  const checkIfFeaturedVehiclesIsActive = activeTab === featuredVehiclesActiveTab;
  const lobbyRadioSelected = 1;

  useEffect(() => {
    if (!allowRequestVehicleInboundAction && allowRequestDockEntryAction) {
      setVehicleActionSelected(2);
    }
    if (allowRequestDockEntryAction && activeTab === vehiclesInLocationActiveTab) {
      setVehicleActionSelected(2);
    }
  }, [allowRequestVehicleInboundAction, allowRequestDockEntryAction, vehicleActionSelected, activeTab]);

  useEffect(() => {
    if (inputDock && inputDock.current) {
      const { input } = inputDock.current;
      input.focus();
    }
  });

  return (
    <Form style={S.FormLayout} layout={"vertical"} form={formVehicleAction} name="vehicleAction">
      <S.VehicleActionContainer>
        <Modal
          destroyOnClose
          title={useTranslation({ id: "call_driver" })}
          centered
          maskClosable={false}
          open={visibleModalVehicleAction}
          confirmLoading={disabledButtonSaveVehicle}
          onOk={() => handleClickConfirmVehicleAction()}
          onCancel={() => lobbyHideModalVehicleAction()}
          okText={useTranslation({ id: "confirm" })}
          cancelText={useTranslation({ id: "cancel" })}
          bodyStyle={{ height: "275px" }}
        >
          <S.DescriptionVehicleAction>{useTranslation({ id: "select_vehicle_action_description" })}</S.DescriptionVehicleAction>
          <S.RadioContainer>
            <Radio.Group
              onChange={onChangeRadioVehicleAction}
              value={vehicleActionSelected}
              style={allowRequestDockEntryAction && allowRequestVehicleInboundAction && checkIfFeaturedVehiclesIsActive ? S.RadioGroup : S.RadioOnlyOption}
            >
              {checkIfFeaturedVehiclesIsActive && allowRequestVehicleInboundAction && (
                <Radio value={1} className="radioButton">
                  {LOBBY}
                </Radio>
              )}
              {allowRequestDockEntryAction && (
                <Radio value={2} className="radioButton">
                  {DOCK}
                </Radio>
              )}
            </Radio.Group>
          </S.RadioContainer>
          {vehicleActionSelected === lobbyRadioSelected ? (
            <S.DescriptionVehicleActionContainer>
              <S.DescriptionVehicleAction>{CALL_VEHICLE_TO_LOBBY_DESCRIPTION}</S.DescriptionVehicleAction>
              <S.DescriptionVehicleAction>{DRIVER_WARNING_DESCRIPTION}</S.DescriptionVehicleAction>
            </S.DescriptionVehicleActionContainer>
          ) : (
            <div>
              <S.FormItem
                name="dock"
                label={`${INFORM_DOCK_ADDRESS}*`}
                rules={[
                  {
                    required: true,
                    message: REQUIRED_FIELD,
                  },
                ]}
              >
                <Input placeholder={ADDRESS} style={S.DockDescriptionField} maxLength={20} ref={inputDock} autoFocus />
              </S.FormItem>
              <S.DriverWarningDescription>{DRIVER_WARNING_DESCRIPTION}</S.DriverWarningDescription>
            </div>
          )}
        </Modal>
      </S.VehicleActionContainer>
    </Form>
  );
};

export default VehicleAction;
